import {FC, useMemo, useState} from 'react';

//formik
import {useFormikContext} from 'formik';
import {CreateEventFormValues, EventSponsor} from '../../../formConfiguration';
//mui
import {Box} from '@mui/material';
//components
import Input from '@/shared/components/Inputs/Input';
import Modal from '@/shared/components/Modal';
import GreyUploadImage from '@/shared/components/UploadDropzone/GreyUploadImage';
//helpers
import {handleGetSponsor} from './helpers';
//constants
import {ADD_SPONSOR, CLOSE, EDIT_SPONSOR, FIELD, FIELD_LABEL, PLACEHOLDER, SAVE_CHANGES} from '@/utils/constants';
//styles
import {addSponsorModalFormStyle} from './AddSponsorModalForm.styles';

interface AddSponsorFormProps {
  onClose: () => void;
  editableSponsor: EventSponsor | null;
  isEditMode?: boolean;
}

const AddSponsorModalForm: FC<AddSponsorFormProps> = ({onClose, editableSponsor, isEditMode}) => {
  const {
    setFieldValue,
    values: {sponsors},
  } = useFormikContext<CreateEventFormValues>();


  const [sponsorLogo, setSponsorLogo] = useState<File | null | string>(editableSponsor?.logo || null);
  const [sponsorName, setSponsorName] = useState<string>(editableSponsor?.name || '');
  const [sponsorOrder, setSponsorOrder] = useState<number>(editableSponsor?.sortOrder || 0);
  const [sponsorCategoryName, setSponsorCategoryName] = useState<string>(editableSponsor?.category?.name || '');

   const isButtonAddEnable = useMemo(
    () => !!sponsorLogo && !!sponsorName && !!sponsorCategoryName,
    [sponsorLogo, sponsorName, sponsorCategoryName]
  );

  const handleSaveAddSponsorModal = async () => {
    const newSponsors = handleGetSponsor(
      sponsors,
      editableSponsor,
      sponsorLogo,
      sponsorName,
      sponsorCategoryName,
      sponsorOrder
    );
    setFieldValue(FIELD.sponsors, newSponsors);
    onClose();
  };

  const handleLogoChange = (logo: File | null) => setSponsorLogo(logo);
  const handleNameChange = (name: string) => setSponsorName(name);
  const handleCategoryNameChange = (name: string) => setSponsorCategoryName(name);

  const modalTitle = useMemo(() => (editableSponsor ? EDIT_SPONSOR : ADD_SPONSOR), [editableSponsor]);
  const modalMainButtonTitle = useMemo(() => (editableSponsor ? SAVE_CHANGES : ADD_SPONSOR), [editableSponsor]);

  return (
    <Modal
      title={modalTitle}
      closeButtonTitle={CLOSE}
      mainButtonTitle={modalMainButtonTitle}
      onClose={onClose}
      onSave={handleSaveAddSponsorModal}
      open
      sx={addSponsorModalFormStyle.modal}
      isSaveButtonDisable={!isButtonAddEnable}
      isShowCloseButton
      isShowSaveButton
    >
      <Box sx={addSponsorModalFormStyle.content}>
        <Box sx={addSponsorModalFormStyle.logoWrapper}>
          <GreyUploadImage
            label={FIELD_LABEL.sponsorLogo}
            onChange={handleLogoChange}
            image={sponsorLogo}
            parentClassName={addSponsorModalFormStyle.logo}
          />
        </Box>
        <Input
          placeholder={PLACEHOLDER.sponsorName}
          label={FIELD_LABEL.sponsorName}
          onChange={handleNameChange}
          value={sponsorName}
        />
        <Input
          placeholder={PLACEHOLDER.sponsorCategory}
          label={FIELD_LABEL.sponsorCategory}
          onChange={handleCategoryNameChange}
		  value={sponsorCategoryName}
        />
      </Box>
    </Modal>
  );
};
export default AddSponsorModalForm;
